import styled from "styled-components";

export const TableButtonWrapper = styled.div`
  & .ant-btn {
    width: 75px;
    height: 22px;
    padding: 0 20px 0 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;

    border: 2px solid #00918e !important;
  }
`;

export const TextStyled = styled.div.attrs((props: { isClosed: boolean }) => ({
  ...props,
}))`
  color: ${props => {
    return props.isClosed ? "#8C8C8C" : "#111111";
  }};
`;
